import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, formatError, wasteLabel } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";
import { ArrowLeft, Image as ImageIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function SubmissionDetailPage() {
  const { id } = useParams();
  const [sub, setSub] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;
    (async () => {
      try {
        const { data } = await api.get(`/submissions/${id}`);
        setSub(data);
        // fetch photo as blob
        const token = localStorage.getItem("rifiuti_token");
        const r = await api.get(`/submissions/${id}/photo?auth=${token}`, { responseType: "blob" });
        objectUrl = URL.createObjectURL(r.data);
        setPhotoUrl(objectUrl);
      } catch (e) { toast.error(formatError(e)); }
    })();
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [id]);

  if (!sub) return <Layout><div className="text-sm text-muted-foreground">Caricamento…</div></Layout>;

  return (
    <Layout
      title={sub.barcode_full ? `Conferimento ${sub.barcode_full}` : "Conferimento in verifica"}
      subtitle={new Date(sub.created_at).toLocaleString("it-IT")}
      actions={<Link to="/dashboard"><Button variant="ghost" className="gap-2" data-testid="back-btn"><ArrowLeft className="w-4 h-4" /> Torna alla dashboard</Button></Link>}
    >
      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2 overflow-hidden">
          <CardContent className="p-0">
            {photoUrl ? (
              <img src={photoUrl} alt="conferimento" className="w-full max-h-[600px] object-contain bg-gray-100" data-testid="sub-photo" />
            ) : (
              <div className="h-96 flex items-center justify-center text-muted-foreground"><ImageIcon className="w-10 h-10" /></div>
            )}
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6 space-y-5">
            <div><div className="text-xs uppercase tracking-widest text-muted-foreground">Stato</div><div className="mt-1"><StatusBadge status={sub.status} /></div></div>
            <div><div className="text-xs uppercase tracking-widest text-muted-foreground">Codice a barre</div><div className="mt-1 font-mono">{sub.barcode_full || <span className="text-amber-600 text-sm font-sans">in attesa di verifica</span>}</div></div>
            <div><div className="text-xs uppercase tracking-widest text-muted-foreground">Tipologia</div><div className="mt-1 font-medium">{wasteLabel(sub.waste_type)}</div></div>
            <div><div className="text-xs uppercase tracking-widest text-muted-foreground">Peso verificato</div><div className="mt-1 font-display text-2xl font-semibold">{sub.verified_weight_kg != null ? `${sub.verified_weight_kg} kg` : <span className="text-amber-600 text-sm font-sans font-normal">in attesa di verifica</span>}</div></div>
            {sub.note_public && (
              <div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Nota dell'operatore</div>
                <div className="mt-1 text-sm p-3 bg-blue-50 border border-blue-100 rounded-lg text-blue-900">{sub.note_public}</div>
              </div>
            )}
            {sub.tari_batch_id && (
              <div className="p-3 bg-emerald-50 border border-emerald-100 rounded-lg text-emerald-900 text-sm">
                Conferimento incluso nel lotto TARI <span className="font-mono text-xs">{sub.tari_batch_id.slice(0, 8)}</span>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
